export const CONFIGURATION_TYPES = Object.freeze({
  EMPTY: {
    name: 'empty',
    title: 'Empty',
    icon: 'file',
    description: 'Create a new vehicle configuration from scratch.'
  },
  IMPORT_FILE: {
    name: 'importFile',
    title: 'Load structure',
    icon: 'file-upload',
    description: `Create a new vehicle configuration based on an
    a JSON file or a C4S ID.`
  }
})

export const INVALID_USERS_ERROR_MESSAGE = 'The following users are invalid:'

export const CONFIGURATION_RESTORE_POINT_TABS = Object.freeze({
  PROPERTIES: {
    key: 'properties',
    label: 'Properties'
  },
  RESTORE_POINT: {
    key: 'restore-point',
    label: 'Config. Restore'
  }
})

export const CONFIG_RESTORE_RECENT_TAB_PROVIDER = 'lastOpenedTabConfigurationRestore'

export const NEW_CONFIGURATION_STEPS = Object.freeze({
  1: 'Select how to start a configuration',
  2: 'Fill in configuration settings',
  3: 'Review configuration setup'
})

export const VALIDATION_LOADING_MESSAGES = Object.freeze({
  FIRST_VALIDATION: 'Validating configuration. Please wait ...',
  DEEP_ANALYSIS: 'Additional analysis in progress. It may take a while...'
})

export const EMPTY_CONFIGURATION_TEMPLATE = Object.freeze({
  name: '',
  project: '',
  c4sCode: '',
  productModel: {},
  planningPeriodRange: { from: '' },
  description: '',
  selectedChoices: [],
  windChillData: { variantSpecNumber: '' }
})

export const PAC_SAVE_TYPES = Object.freeze({
  NONE: 'none',
  CURRENT: 'current',
  NEW: 'new'
})

export const PAC_CONFIGS_TABS = Object.freeze({
  ALL: { key: 'options', value: 'All options' },
  INVALID: { key: 'invalidOptions', value: 'Invalid results' }
})

export const USER_PERMISSION_OPTIONS = Object.freeze({
  OPTIONS: ['Everyone', 'Selected users'],
  EVERYONE: 'Everyone',
  SELECTED_USERS: 'Selected users'
})

// editorconfig-checker-disable
// eslint-disable-next-line
export const EXPLANATION_RULE_WINDCHILL_LINK = 'https://mucwtprod.mn-man.biz:40049/Windchill/app/#ptc1/tcomp/infoPage?ContainerOid=OR%3Awt.inf.library.WTLibrary%3A104026&oid=OR%3A{ruleId}&u8=1'

// editorconfig-checker-enable

// eslint-disable-next-line max-len,vue/max-len
export const NO_RECOVERY_SUGGESTIONS_AVAILABLE_MESSAGE = 'Error: This combination is invalid, but no recovery suggestions were found.'
